
export const DRAFT = 1;
export const AUTHORISATION_PENDING = 2;
export const AUTHORISATION_REJECTED = 3;
export const AUTHORISED = 4;
export const IN_PROGRESS = 5;
export const UPLOADED_FOR_REVIEW = 6;
export const CHECK_REJECTED = 7;
export const APPROVAL_REJECTED = 8;
export const AWAITING_POST_COMPLETION = 9;
export const COMPLETED = 10;
export const CANCELLED = 11;

// Current job workflow IDs. The older constants above are retained for dormant
// job-revamp code that has not been reactivated.
export const FOR_APPROVAL = 2;
export const JOB_REJECTED = 7;
export const JOB_COMPLETED = 8;
export const JOB_APPROVAL_REJECTED = 9;
export const FOR_APPROVAL_FILTER = 8;

export const jobRequiresApproval = (job) =>
    job?.enforceJobAuth === true || job?.requiresApproval === true;

export const isJobAwaitingApproval = (job) =>
    jobRequiresApproval(job) && job?.jobStatusId === FOR_APPROVAL;

export const isJobApprovalRejected = (job) =>
    jobRequiresApproval(job) && job?.jobStatusId === JOB_APPROVAL_REJECTED;

export const hasJobApprovalWorkflowHold = (job) =>
    isJobAwaitingApproval(job) || isJobApprovalRejected(job);

export const getJobAllocatedUser = (job) => {
    if (isJobAwaitingApproval(job)) return job?.authoriserUser;
    if (isJobApprovalRejected(job)) return job?.createdByUser;
    return job?.assignedUser;
};
